// Opciones del onboarding. La `clave` es un CÓDIGO ESTABLE que se guarda en la
// base y sirve para graficar: no la cambies. La etiqueta (`label`) sí se puede
// editar libremente sin romper las métricas.

// País del negocio (para saber desde qué países usan la app y ajustar el
// código de WhatsApp). Los nombres coinciden con utils/paises.js.
export const PAISES = [
  'Honduras', 'Guatemala', 'El Salvador', 'Nicaragua', 'Costa Rica', 'Panamá',
  'México', 'Estados Unidos', 'Colombia', 'Ecuador', 'Perú', 'Chile',
  'Argentina', 'España', 'República Dominicana', 'Otro',
];

export const TIPOS_USUARIO = [
  { clave: 'emprendedor', label: 'Emprendedor', emoji: '🚀' },
  { clave: 'dueno_negocio', label: 'Dueño de negocio', emoji: '🏪' },
  { clave: 'otro', label: 'Otro', emoji: '✨' },
];

export const RUBROS = [
  { clave: 'moda', label: 'Ropa y moda', emoji: '👗' },
  { clave: 'comida', label: 'Comida y restaurante', emoji: '🍔' },
  { clave: 'belleza', label: 'Belleza y estética', emoji: '💅' },
  { clave: 'salud', label: 'Salud y bienestar', emoji: '🩺' },
  { clave: 'viajes', label: 'Agencia de viajes', emoji: '✈️' },
  { clave: 'servicios_prof', label: 'Servicios profesionales', emoji: '💼' },
  { clave: 'tecnologia', label: 'Tecnología', emoji: '💻' },
  { clave: 'educacion', label: 'Educación', emoji: '📚' },
  { clave: 'tienda', label: 'Tienda / abarrotes', emoji: '🛒' },
  { clave: 'distribuidor', label: 'Distribuidor', emoji: '🚚' },
  { clave: 'construccion', label: 'Construcción / ferretería', emoji: '🔨' },
  { clave: 'automotriz', label: 'Automotriz', emoji: '🚗' },
  { clave: 'agro', label: 'Agropecuario', emoji: '🌱' },
  { clave: 'otro', label: 'Otro', emoji: '✨' },
];

export const EMPLEADOS = [
  { clave: 'solo_yo', label: 'Solo yo' },
  { clave: '2_5', label: '2 a 5' },
  { clave: '6_10', label: '6 a 10' },
  { clave: '11_25', label: '11 a 25' },
  { clave: '26_mas', label: '26 o más' },
];

export const ANTIGUEDAD = [
  { clave: 'menos_1', label: 'Menos de 1 año' },
  { clave: '1_3', label: '1 a 3 años' },
  { clave: '3_5', label: '3 a 5 años' },
  { clave: '5_mas', label: 'Más de 5 años' },
];

// Rango de ventas al mes (aproximado, en la moneda del usuario). Rangos, nunca
// una cifra exacta, para que sea cómodo de responder.
export const TAMANO_VENTAS = [
  { clave: 'menos_10k', label: 'Menos de 10 mil' },
  { clave: '10k_50k', label: '10 mil a 50 mil' },
  { clave: '50k_150k', label: '50 mil a 150 mil' },
  { clave: '150k_500k', label: '150 mil a 500 mil' },
  { clave: '500k_mas', label: 'Más de 500 mil' },
  { clave: 'prefiero_no_decir', label: 'Prefiero no decir' },
];

export const OBJETIVOS = [
  { clave: 'controlar_inventario', label: 'Controlar mi inventario', emoji: '📦' },
  { clave: 'registrar_ventas', label: 'Registrar mis ventas', emoji: '🛒' },
  { clave: 'controlar_dinero', label: 'Controlar el dinero', emoji: '💰' },
  { clave: 'cotizar_servicios', label: 'Cotizar y vender servicios', emoji: '🧾' },
  { clave: 'organizar_clientes', label: 'Organizar mis clientes', emoji: '👥' },
  { clave: 'crecer', label: 'Hacer crecer el negocio', emoji: '📈' },
  { clave: 'otro', label: 'Otro', emoji: '✨' },
];

export const NECESIDADES = [
  { clave: 'orden', label: 'Tener todo más ordenado', emoji: '🗂️' },
  { clave: 'saber_ganancia', label: 'Saber cuánto gano', emoji: '💵' },
  { clave: 'controlar_stock', label: 'No quedarme sin stock', emoji: '📦' },
  { clave: 'cobrar_creditos', label: 'Cobrar lo que me deben', emoji: '⏰' },
  { clave: 'vender_mas', label: 'Vender más', emoji: '🚀' },
  { clave: 'ahorrar_tiempo', label: 'Ahorrar tiempo', emoji: '⏳' },
  { clave: 'imagen_pro', label: 'Verme más profesional', emoji: '✨' },
  { clave: 'controlar_gastos', label: 'Controlar mis gastos', emoji: '🧾' },
];

export const COMO_CONOCIO = [
  { clave: 'recomendacion', label: 'Me lo recomendaron', emoji: '🗣️' },
  { clave: 'redes', label: 'Redes sociales', emoji: '📱' },
  { clave: 'google', label: 'Buscando en Google', emoji: '🔎' },
  { clave: 'automatika', label: 'Por Automatika.IA', emoji: '🤖' },
  { clave: 'anuncio', label: 'Un anuncio', emoji: '📣' },
  { clave: 'otro', label: 'Otro', emoji: '✨' },
];
